<div class="voting">
  <h4 class="main-title">{{ 'meetings.Voting' | translate }}</h4>

  <div class="dataLoading" *ngIf="dataLoading">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>

  <div class="questionVotingSection" *ngIf="!dataLoading">

    <ng-container *ngIf="!currentVote">
      <div class="agenda-voting-container" *ngIf="!showSetVotingTime">
        <div class="no-voting">
          <img src="./assets/images/icons/allow-for-voting-illustration.svg" alt="">
          <div *ngIf="votingListData.canAdd">
            <button class="btn btn-primary" (click)="showSetVotingTime = true">
              <ng-container *ngIf="module == votingView.Plan">
                {{ 'case.Allow Voting on Treatment Plan' | translate }}
              </ng-container>
              <ng-container *ngIf="module == votingView.Recommend">
                {{ 'case.Allow Voting on Recommendations' | translate }}
              </ng-container>
            </button>
          </div>
        </div>
      </div>

      <div class="timer-container" *ngIf="showSetVotingTime">
        <div class="vote-time">
          <div class="title">
            <div *ngIf="module == votingView.Plan">{{ 'case.Allow Voting on Treatment Plan' | translate }}</div>
            <div *ngIf="module == votingView.Recommend">{{ 'case.Allow Voting on Recommendations' | translate }}</div>
            <button class="btn" (click)="showSetVotingTime = false;">
              <img src="./assets/images/icons/close-btn.svg" alt="">
            </button>
          </div>

          <div class="set-time">
            <svg width="16" height="16" viewBox="0 0 16 16">
              <path id="time-icon"
                d="M8,0a8,8,0,1,0,8,8A8.009,8.009,0,0,0,8,0Zm3.8,12.138a.666.666,0,0,1-.943,0L7.529,8.8a.664.664,0,0,1-.2-.471V4A.667.667,0,1,1,8.667,4V8.057L11.8,11.2a.666.666,0,0,1,0,.943Zm0,0"
                fill="#ccc" />
            </svg>
            <label> {{ 'meetings.Durationvoting' | translate }}:</label>
            <div class="form-elements">
              <div class="form-group">
                <input matInput class="form-control" type="number" appOnlynumber min="1" max="999"
                  [(ngModel)]="votingAnswerTime" [ngModelOptions]="{standalone: true}">
              </div>
            </div>
            <span> {{ 'meetings.minutes' | translate }}</span>

            <div class="btn-start">
              <button class="btn btn-primary" [disabled]="startVoteLoading" (click)="startVote()">
                <svg width="13" height="17" viewBox="0 0 13 17">
                  <path id="play-icon"
                    d="M73.562,6.921,63.947.457A2.374,2.374,0,0,0,62.684,0c-.719,0-1.164.567-1.164,1.515V15.487c0,.947.444,1.513,1.161,1.513a2.354,2.354,0,0,0,1.258-.458l9.62-6.464A1.932,1.932,0,0,0,74.52,8.5,1.926,1.926,0,0,0,73.562,6.921Z"
                    transform="translate(-61.52)" fill="#fff" />
                </svg>
                {{ 'meetings.Start' | translate }}
              </button>
            </div>
          </div>

          <p class="has-error" *ngIf="startVoteSubmit && !votingAnswerTime">{{'case.Please insert Duration Time' |
            translate}}</p>
        </div>
      </div>

      <div class="voting-history mt-3" *ngIf="votingListData.pageData.length && !showSetVotingTime">
        <h4 class="main-title mb-4" *ngIf="votingListData.canAdd || true">
          {{ 'case.Voting history' | translate }}
        </h4>
        <mat-tab-group class="mat-tabs-primary">
          <mat-tab *ngFor="let voting of votingListData.pageData" [label]="voting.title">
            <ng-container [ngTemplateOutlet]="votingTabs" [ngTemplateOutletContext]='{voting: voting}'></ng-container>
          </mat-tab>
        </mat-tab-group>
      </div>
    </ng-container>

    <ng-container *ngIf="currentVote">
      <div class="timer">
        <countdown #cd [config]="{ leftTime: (currentVote.votingRemainingTime*60), format: 'mm:ss' }"
          (event)="timesUp($event)">
        </countdown>
      </div>

      <div class="type-selector mb-5" *ngIf="!currentVote.isOwner">
        <mat-radio-group [(ngModel)]="voteAnswerValue" (change)="submitVote()">
          <mat-radio-button *ngFor="let option of currentVote.voteOption" [value]="option.id">{{ option.title
            }}</mat-radio-button>
        </mat-radio-group>
      </div>

      <ng-container [ngTemplateOutlet]="votingTabs" [ngTemplateOutletContext]='{voting: currentVote}'></ng-container>

      <div class="stop-footer" *ngIf="canEndVote && currentVote.isOwner">
        <span>
          {{ 'case.All attendees voted' | translate }}
        </span>
        <button class="btn btn-primary" (click)="closeVote()">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
            <rect id="stop-icon" width="12" height="12" rx="2" fill="#fff" />
          </svg>
          {{ 'meetings.Stop' | translate }}
        </button>
      </div>
    </ng-container>

  </div>
</div>


<ng-template #votingTabs let-voting="voting">
  <div class="voting-tabs">

    <ng-container *ngIf="voting.votingClosed">
      <ng-container *ngIf="module == votingView.Plan">
        <div class="alert alert-success" *ngIf="voting.treatmentPlanApproved">
          {{'case.The treatment plan was approved by majority vote' | translate}}
        </div>
        <div class="alert alert-danger" *ngIf="!voting.treatmentPlanApproved">
          {{'case.The treatment plan was declined by majority vote' | translate}}
        </div>
      </ng-container>

      <ng-container *ngIf="module == votingView.Recommend">
        <div class="alert alert-success" *ngIf="voting.recommendationApproved">
          {{'case.The recommendations was approved by majority vote' | translate}}
        </div>
        <div class="alert alert-danger" *ngIf="!voting.recommendationApproved">
          {{'case.The recommendations was declined by majority vote' | translate}}
        </div>
      </ng-container>

      <div class="vote-time-info">
        <img src="./assets/images/icons/time-icon.svg" alt="">
        {{ 'meetings.Votingwasavailablefor' | translate }}
        <span>{{voting.votingTime}}</span>
        {{ 'meetings.minutes' | translate }}
      </div>
    </ng-container>

    <div class="primary-tabs">
      <div class="tabs-nav">
        <label *ngFor='let tab of tabs' (click)='currentTabVal = tab.value'
          [class.active]='currentTabVal == tab.value'>{{tab.label}}</label>
      </div>
    </div>

    <div class="tabs-container tabs-section">

      <div class="attendees-answers" *ngIf="currentTabVal == 0">
        <div class="message-comments-container" *ngIf="voting.attendeeVotingAnswers.length">
          <div class="comments-list">
            <div class="comment-panel" *ngFor="let vote of voting.attendeeVotingAnswers; index as i;">
              <div class="reply-header d-sm-flex justify-content-between align-items-center">
                <div class="name-with-image small mb-3 mb-sm-0">
                  <div class="image-circle" [title]="vote.creator.creatorName">
                    <img *ngIf="vote.creator.creatorProfilePicture" [src]="vote.creator.creatorProfilePicture"
                      (error)="vote.creator.creatorProfilePicture = ''" />
                    <span *ngIf="!vote.creator.creatorProfilePicture">{{ vote.creator.creatorName | shortName }}</span>
                  </div>
                  <div class="name">
                    <h5>{{vote.creator.creatorName}}</h5>
                  </div>
                  <div class="delegated-user" *ngIf="vote.delegator && vote.delegator.creatorId">
                    <img class="delegated-arrow" src="./assets/images/icons/arrow-delegate-icon.svg">
                    <div class="image-circle" [title]="vote.delegator.creatorName">
                      <img *ngIf="vote.delegator.creatorProfilePicture" [src]="vote.delegator.creatorProfilePicture"
                        (error)="vote.delegator.creatorProfilePicture = ''" />
                      <span *ngIf="!vote.delegator.creatorProfilePicture">{{ vote.delegator.creatorName | shortName
                        }}</span>
                    </div>
                    <div class="creatorName">
                      ({{vote.delegator.creatorName}})
                    </div>
                  </div>
                </div>

                <div class="text-lg-right">
                  <p class="time-from">{{vote.answerDate | timeAgo}}</p>
                </div>
              </div>
              <div class="reply-content" [ngClass]="{'has-delegator': vote.delegator && vote.delegator.creatorId}">
                <div class="reply-body pt-1">
                  <div class="badge" [ngClass]="{
                      'badge-success': vote.lookup == 'Approved',
                      'badge-danger': vote.lookup == 'Declined',
                      'badge-secondary': vote.lookup == 'Abstain'
                    }">{{vote.answer}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="no-document pt-0" *ngIf="!voting.attendeeVotingAnswers.length">
          <img src="./assets/images/icons/no-comments.svg" alt="">
          <p> {{ 'case.No one vote yet' | translate }}!</p>
        </div>
      </div>

      <div class="summary" *ngIf="currentTabVal == 1">
        <ng-container *ngIf='voting.votingSummaryList.length'>
          <ul class="summery-progress">
            <li *ngFor="let item of voting.votingSummaryList; let i=index">
              <div class="sum-info">
                <span>{{item.title}}</span>
                <div class="stat">
                  <span class="perc">{{item.percentage | number:'1.0-2'}}%</span>
                  <span>
                    (
                    {{item.votesNumber}} <span *ngIf="item.votesNumber != 1"> {{ 'meetings.votes' | translate }}</span>
                    <span *ngIf="item.votesNumber == 1">{{ 'meetings.avote' | translate }}</span>
                    )
                  </span>
                </div>
              </div>
              <mat-progress-bar mode="determinate" [value]="item.percentage"></mat-progress-bar>
            </li>
          </ul>
        </ng-container>

        <div class="no-document pt-0" *ngIf='!voting.votingSummaryList.length'>
          <img src="./assets/images/icons/no-comments.svg" alt="">
          <p> {{ 'meetings.Nosummaryyet' | translate }}!</p>
        </div>
      </div>

      <div *ngIf="currentTabVal == 2">
        <div class="crud-list-wrapper">
          <div class="crud-list-container">
            <div class="crud-list">
              <div class="crud-control" *ngFor="let item of voting.history; index as i;">
                <span class="list-icon">
                  <svg width="14" height="14" viewBox="0 0 14 14">
                    <path id="listing-icon"
                      d="M3.809,6l-.33.329a.46.46,0,0,0,0,.651l2.5,2.5a.461.461,0,0,0,.651,0L12.99,3.125a.46.46,0,0,0,0-.651l-.33-.329a.461.461,0,0,0-.651,0L6.633,7.515a.461.461,0,0,1-.651,0L4.46,6A.461.461,0,0,0,3.809,6Zm9.248,1a.46.46,0,0,0-.459.425A5.606,5.606,0,1,1,7.008,1.4a5.524,5.524,0,0,1,1.3.146.462.462,0,0,0,.433-.122l.388-.388A.46.46,0,0,0,8.912.265,7.643,7.643,0,0,0,7.008,0,7,7,0,1,0,14,7.5a.461.461,0,0,0-.459-.5Z"
                      fill="#aaa" />
                  </svg>
                </span>
                <div>
                  <div class="form-control" *ngIf="!item.medicalPhase">{{item.recommendation}}</div>

                  <div class="form-control" *ngIf="item.medicalPhase">
                    <span class="fontSemiBold">{{item.medicalPhase.name}}</span>:
                    {{item.medicalPhasefields[0].fieldname}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</ng-template>
